module.exports = __webpack_public_path__ + "img/warning.90008867.svg";